export default (start, end, block) => {
    let content = '';
    for (let i = start; i < end; i++) {
        content += block.fn(i);
    }
    return content;
};
